import { $SCOPE_SERVICE_NAME } from '../../../services/system'
import { LocalizationHelper } from '../../../helpers'

//#region Asset Imports

import './cookie-banner.scss'
import * as TEMPLATE from './cookie-banner.tpl.html'

//#endregion

export interface CookieBannerScope extends ng.IScope {
	bannerHidden: boolean
	message: string
	acceptText: string

	accept()
}

export class CookieBannerDirective implements ng.IDirective {
	protected keyAccepted = 'SIMAX-cl'
	protected oldValueAccepted = 'accepted'
	protected newValueAccepted = 'Accepted' //with secure=true
	protected expireDays = 365

	restrict = 'E'

	controller = [
		$SCOPE_SERVICE_NAME,
		'$cookies',
		($scope: CookieBannerScope, $cookies: ng.cookies.ICookiesService) => {
			$scope.bannerHidden = true

			const t: string = $cookies.get(this.keyAccepted)

			if (t != this.newValueAccepted) {
				$cookies.remove(this.keyAccepted)
				$scope.bannerHidden = false
			}

			$scope.message = LocalizationHelper.getLocalizedText('CookiesLawMessage')
			$scope.acceptText = LocalizationHelper.getLocalizedText('Understand')

			const cookieAccept = () => {
				const expireDate: Date = new Date()
				expireDate.setTime(expireDate.getTime() + this.expireDays * 24 * 60 * 60 * 1000)
				$cookies.put(this.keyAccepted, this.newValueAccepted, { expires: expireDate, secure: true })

				$scope.bannerHidden = true
			}

			$scope.accept = cookieAccept
		},
	]

	template = TEMPLATE
	replace = true
}
